import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceToolsCertificationDialogComponent } from './service-tools-certification-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    declarations: [ServiceToolsCertificationDialogComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule],
    exports: [ServiceToolsCertificationDialogComponent],
})
export class ServiceToolsCertificationDialogModule {}
